import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import SweetAlert from "react-bootstrap-sweetalert";

const customStyles = {
    control: (provided, state) => ({
        ...provided,
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        backgroundColor: state.isDisabled ? "#e9ecef" : provided.backgroundColor
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        cursor: state.isDisabled ? "not-allowed" : "pointer"
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        cursor: state.isDisabled ? "not-allowed" : "pointer"
    }),
    container: (provided, state) => ({
        ...provided,
        cursor: state.isDisabled ? "not-allowed" : "pointer"
    })
};

const AddEditController = ({ resource, closeSlider, onUpdate }) => {
    const { open, title, type, btnType, formResourceArray, formData } = resource;
    const [currentData, setCurrentData] = useState(formData || {});
    const [formResourceData, setFormResourceData] = useState(formResourceArray || []);
    const [show, setShow] = useState(false);
    const [basicType, setBasicType] = useState("");
    const [basicTitle, setBasicTitle] = useState("");
    const submittingRef = useRef(false);
    const closeAlert = () => setShow(false);
    const showValidationAlert = (message) => {
        setShow(true);
        setBasicType("warning");
        setBasicTitle(message);
    };

    useEffect(() => {
        setCurrentData(formData || {});
    }, [formData]);
    useEffect(() => {
        setFormResourceData(formResourceArray || []);
    }, [formResourceArray]);

    console.log(resource, formData)
    const renderField = (each) => {

        if (each.type === "dropdown") {

            // Debug: print dropdown options and current selected value
            console.log(each.optionsArray, currentData[each.field]);

            return (
                <Select
                    // Dropdown options list
                    options={each.optionsArray}

                    // Set selected value based on currentData
                    // It finds the matching option object from optionsArray
                    value={
                        each.optionsArray.find(
                            (option) => option.value === currentData[each.field]
                        ) || null // if not found, show empty
                    }

                    // When user selects a value
                    onChange={(selected) => {

                        // Update currentData with selected value
                        setCurrentData((prev) => ({
                            ...prev,
                            [each.field]: selected ? selected.value : ""
                        }));

                        // If dropdown is "city" and its options carry an associated state, auto-fill state
                        if (each.field == "city" && selected && selected.state !== undefined) {

                            // Automatically set state based on selected city
                            setCurrentData((prev) => ({
                                ...prev,
                                ["state"]: selected.state
                            }));

                        }
                        // If dropdown is "clubbing_type"
                        else if (each.field == "clubbing_type") {

                            // Update formResourceData dynamically
                            setFormResourceData((prevState) => {
                                return [

                                    // Keep already active fields
                                    ...prevState.filter((each) => each.is_active && !["intra_city_charge", "inter_city_charge"].includes(each.field)),

                                    // If selected value = 0 → add intra_city_charge field
                                    ...(selected.value == "intra_city" ? [{
                                        ...formResourceData.find((each) => each.field == "intra_city_charge"),
                                        is_active: true
                                    }, {
                                        ...formResourceData.find((each) => each.field == "inter_city_charge"),
                                        is_active: false
                                    }] : []),

                                    // If selected value = 1 → add inter_city_charge field
                                    ...(selected.value == "inter_city" ? [{
                                        ...formResourceData.find((each) => each.field == "inter_city_charge"),
                                        is_active: true
                                    }, {
                                        ...formResourceData.find((each) => each.field == "intra_city_charge"),
                                        is_active: false
                                    }] : [])
                                ];
                            });
                        }
                    }}

                    // Styling
                    classNamePrefix="react-select"
                    className="mb-2 mt-2"
                    menuPlacement="auto"

                    // Disable dropdown if needed
                    isDisabled={each.is_disabled}

                    // Optional per field. An OPTIONAL dropdown needs a way back to "no value" -
                    // without isClearable, once something is picked it can never be emptied
                    // again. Both default to react-select's own behaviour when not set, so
                    // every existing dropdown is unchanged.
                    isClearable={!!each.isClearable}
                    placeholder={each.placeholder}

                    // Custom styles
                    styles={customStyles}
                />
            );
        }

        if (each.type === "creatable-dropdown") {
            // Same as "dropdown" above, but the user can also type a value
            // that isn't in optionsArray and it becomes a new option instead
            // of being rejected - for fields like SOB Zones' Zone, where the
            // list used to be a fixed set someone had to hardcode by hand.
            // blockSpaces (opt-in per field) strips spaces only from a newly
            // CREATED value - typing/searching itself is left alone, since
            // stripping spaces as the user types would also break searching
            // for an existing multi-word option (e.g. "NORTH EAST").
            return (
                <CreatableSelect
                    options={each.optionsArray}
                    value={
                        each.optionsArray.find(
                            (option) => option.value === currentData[each.field]
                        ) || (currentData[each.field] ? { label: currentData[each.field], value: currentData[each.field] } : null)
                    }
                    onChange={(selected, actionMeta) => {
                        var value = selected ? selected.value : "";
                        // Only strip spaces when a NEW value is being created -
                        // an existing option (e.g. "NORTH EAST") must stay
                        // selectable exactly as it already is.
                        if (each.blockSpaces && actionMeta && actionMeta.action === "create-option") {
                            value = String(value || "").replace(/\s/g, "");
                        }
                        if (each.normalizeCase) {
                            value = String(value || "").trim().toUpperCase();
                        }
                        setCurrentData((prev) => ({
                            ...prev,
                            [each.field]: value
                        }));
                    }}
                    classNamePrefix="react-select"
                    className="mb-2 mt-2"
                    menuPlacement="auto"
                    isDisabled={each.is_disabled}
                    styles={customStyles}
                    placeholder={each.placeholder}
                />
            );
        }

        if (each.type === "multiselect") {
            var selectedValues = Array.isArray(currentData[each.field]) ? currentData[each.field] : [];
            return (
                <Select
                    isMulti
                    options={each.optionsArray}
                    value={each.optionsArray.filter((option) => selectedValues.indexOf(option.value) !== -1)}
                    onChange={(selected) => {
                        var values = (selected || []).map((option) => option.value);
                        if (typeof each.onSelectValues === "function") {
                            values = each.onSelectValues(values, selectedValues);
                        }
                        setCurrentData((prev) => ({
                            ...prev,
                            [each.field]: values
                        }));
                    }}
                    classNamePrefix="react-select"
                    className="mb-2 mt-2"
                    menuPlacement="auto"
                    isDisabled={each.is_disabled}
                    styles={customStyles}
                />
            );
        }

        if (each.type === "input") {
            // TEXT INPUT
            if (each.input_type === "text") {
                return (
                    <input
                        type="text"
                        name={each.field}
                        value={currentData[each.field] || ""}
                        onChange={(e) => {
                            console.log(e.target.value, each, currentData)
                            const value = e.target.value; 
                            setCurrentData((prev) => ({
                                ...prev,
                                [each.field]: value
                            }));
                        }}
                        className="mb-2 mt-2"
                        disabled={each.is_disabled}
                        style={{ cursor: each.is_disabled ? "not-allowed" : "text", backgroundColor: each.is_disabled ? "#e9ecef" : "#fff" }}
                    />
                );
            }

            // NUMBER INPUT (positive float only)
            if (each.input_type === "number") {
                return (
                    <>
                    <input
                        type="text"
                        name={each.field}
                        // value={(currentData[each.field]).toString() || ""}
                        value={currentData[each.field] != null ? String(currentData[each.field]) : ""}
                        onChange={(e) => {
                            let value = e.target.value;

                            // allow empty
                            if (value === "") {
                                setCurrentData((prev) => ({
                                    ...prev,
                                    [each.field]: value
                                }));
                                return;
                            }

                            // is_integer fields accept whole numbers only (no decimal point)
                            if (each.is_integer) {
                                if (!/^\d*$/.test(value)) return;
                                setCurrentData((prev) => ({
                                    ...prev,
                                    [each.field]: value
                                }));
                                return;
                            }

                            // allow only positive numbers / floats
                            const regex = /^\d*\.?\d*$/;

                            if (!regex.test(value)) return;

                            // prevent multiple dots
                            if ((value.match(/\./g) || []).length > 1) return;

                            setCurrentData((prev) => ({
                                ...prev,
                                [each.field]: value
                            }));
                        }}
                        className="mb-2 mt-2"
                        disabled={each.is_disabled}
                        style={{ cursor: each.is_disabled ? "not-allowed" : "text", backgroundColor: each.is_disabled ? "#e9ecef" : "#fff" }}
                    />
                    {/* <p className="m-0 text-info">only positive numericals accepted</p> */}
                    </>
                );
            }
        }

        return <div>Invalid component</div>;
    };

    const onClickSubmit = async () => {
        // One submit at a time: a field validator can wait on the server, and a second click in
        // that window would otherwise submit the same record twice.
        if (submittingRef.current) return;
        submittingRef.current = true;
        try {
            await submitOnce();
        } finally {
            submittingRef.current = false;
        }
    };

    const submitOnce = async () => {
        for (let field of formResourceData) {
            var fieldValue = currentData[field.field];
            var isMissing = Array.isArray(fieldValue) ? fieldValue.length === 0 : (!fieldValue && fieldValue !== 0);
            // A field with its own `validate` decides for itself whether a blank is acceptable
            // (e.g. mandatory only when nothing is on record yet), so the plain check skips it.
            if (field.is_active && field.is_required && isMissing && typeof field.validate !== "function") {
                showValidationAlert(field.errMsg);
                return;
            }
        }
        // Optional per-field validator: async (value, allValues) => error message, or a falsy
        // value when the field is fine. Runs after the plain required checks, in field order.
        for (let field of formResourceData) {
            if (!field.is_active || typeof field.validate !== "function") continue;
            var problem = await field.validate(currentData[field.field], currentData);
            if (problem) {
                showValidationAlert(problem);
                return;
            }
        }

        if (type === "update") {
            var hasChanges = formResourceData.some((field) => {
                if (!field.is_active) return false;
                var oldValue = formData && formData[field.field] !== undefined && formData[field.field] !== null ? String(formData[field.field]) : "";
                var newValue = currentData[field.field] !== undefined && currentData[field.field] !== null ? String(currentData[field.field]) : "";
                return oldValue !== newValue;
            });
            if (!hasChanges) {
                showValidationAlert("No changes found. Please modify at least one field before updating.");
                return;
            }
        }

        // awaited so the guard above holds until the screen's save has finished
        await onUpdate(currentData, type);
    };

    console.log(formResourceData)
    return (
        <div className={`hub-slider ${open ? "open" : ""} d-flex flex-column`}>
            <SweetAlert
                show={show}
                type={basicType}
                title={basicTitle}
                onConfirm={closeAlert}
                styles={{ zIndex: "10000001" }}
            >
            </SweetAlert>
            <div className="slider-header">
                {title}
                <span onClick={closeSlider} style={{cursor: "pointer"}}>✕</span>
            </div>

            {/* bottom room so a dropdown that is the LAST field can open its menu inside the
                scroll area instead of being clipped behind the footer buttons */}
            <div className="slider-body flex-grow-1 pt-4" style={{ paddingBottom: "160px" }}>
                {formResourceData
                    .filter((each) => each.is_active)
                    .map((each) => (
                        <div key={each.id} id={`field-${each.id}`} className="d-flex flex-column">
                            <label className="m-0">
                                {each.title}{" "}
                                {each.is_required && (
                                    <span className="text-danger">*</span>
                                )}
                            </label>
                            {renderField(each)}
                            {/* Optional help text under a field, for rules that are not obvious
                                from the label alone (e.g. a value that only applies on this tab). */}
                            {each.note && (
                                <small className="text-muted" style={{ marginTop: "-6px", marginBottom: "8px" }}>
                                    {each.note}
                                </small>
                            )}
                        </div>
                    ))}
            </div>

            <div className="slider-footer">
                <button
                    className="save-btn"
                    style={{ margin: "0px" }}
                    onClick={onClickSubmit}
                >
                    {btnType}
                </button>
            </div>
        </div>
    );
};

export default AddEditController;